import { useState, useRef, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

/**
 * check if a previous value has changed
 *
 * @param {any} val
 */
export const useHasChanged = (val) => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => void (ref.current = value), [value]);
  return ref.current;
}

export function useMeasure() {
  const ref = useRef();
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [ro] = useState(
    () => new ResizeObserver(([entry]) => set(entry.contentRect))
  );
  useEffect(() => {
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  });
  return [{ ref }, bounds];
}

// Hook
export function useOnScreen(ref, rootMargin = '0px') {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    let current_ref = ref.current;
    if (current_ref) {
      observer.observe(current_ref);
    }
    return () => {
      observer.unobserve(current_ref);
    };
  }); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
}
